document.addEventListener("wishlist-hero-wishlist-sdk-ready", async function(e) {
    var wishlist_item_count = window.WishListHero_SDK.GetWishListItemsCount();
    document.querySelector(".wishlist_count").innerHTML = "(" + wishlist_item_count + ")";
    if (wishlist_item_count == 0) {
        document.querySelector('.wishlist_no_item').style.display = 'block';
    } else {
        document.querySelector('.wishlist_no_item').style.display = 'none';
    }
    var wishlistItems = window.WishListHero_SDK.GetWishListItems();
    var wishlisthtml = '';
    wishlisthtml += '<div class="main_wishlist_page-wrapper">';
    for (let i = 0; i < wishlistItems.length; i++) {
  var getcurrency = wishlistItems[i].DisplayCurrency;
  var rounded_value = Math.round(wishlistItems[i].Price);
   var currency_price = (rounded_value).toLocaleString('en-US', {style: 'currency',currency: getcurrency,}); 
  var removed_zerrs = currency_price.replace(".00","");
        wishlisthtml += '<div class="main_wishlistinner-rpeater size_popup-parent" variantid="' + wishlistItems[i].ProductVariantId + '"><div class="wishlist-product-image"><a href="' + wishlistItems[i].ProductLink + '"><img src="' + wishlistItems[i].ProductImage + '"></a><div class="product_varinats_wrapp"></div><div class="wishlist_cross_btn"><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 1.32031L1.00006 17.8203" stroke="black" stroke-linecap="round"/><path d="M17.5 17.8203L1.00006 1.32037" stroke="black" stroke-linecap="round"/></svg></div></div><div class="wishlist-product-info"><a href="' + wishlistItems[i].ProductLink + '"><div class="wishlist-product-title">' + wishlistItems[i].ProductName + '</div><div class="wshlist-product-description"></div><div class="wishlist-pro-price">' + removed_zerrs + '</div></a></div></div>';
    }
    wishlisthtml += '</div>';
    console.log(wishlistItems);
    document.querySelector(".wishlist_product_here").innerHTML = wishlisthtml;
    document.querySelectorAll('.main_wishlistinner-rpeater').forEach(function(element) {
        var get_wishlist_url = element.querySelector('.wishlist-product-image a').getAttribute('href');
        var thisitem = element;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', get_wishlist_url, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status === 200) {
                var response = xhr.responseText;
                var parser = new DOMParser();
                var htmlDoc = parser.parseFromString(response, 'text/html');
                thisitem.querySelector('.wshlist-product-description').innerHTML = htmlDoc.querySelector('.WishtListDesc').innerHTML;
                thisitem.querySelector('.product_varinats_wrapp').innerHTML = htmlDoc.querySelector('.wishlist_pro-data-pick').innerHTML;
            }
        };
        xhr.send();
    });
$(".main_wishlistinner-rpeater").each(function() {
  var data_url = $(this).find(".wishlist-product-image a").attr("href");
    var thisitem = $(this);
    if (window.location.href.indexOf("/fr/") > -1) {
 if (data_url.indexOf("/fr/") > -1) {
  jQuery.ajax({
    type: 'GET',
    url: data_url,
    dataType: 'json',
    success: function(json_data){  
    $(thisitem).find(".wishlist-product-title").html(json_data.product.title);
    $(thisitem).find(".wishlist-product-image a").attr("href",data_url);
    },
  });
 }else{
     var final_url="/fr"+data_url;
       jQuery.ajax({
    type: 'GET',
    url: final_url,
    dataType: 'json',
    success: function(json_data){  
   $(thisitem).find(".wishlist-product-title").html(json_data.product.title);
         $(thisitem).find(".wishlist-product-image a").attr("href",final_url);
    },
  });
 }
    }else{
         if (data_url.indexOf("/fr/") > -1) {
              var final_url= data_url.split("/fr")[1];
  jQuery.ajax({
    type: 'GET',
    url: final_url,
    dataType: 'json',
    success: function(json_data){  
        $(thisitem).find(".wishlist-product-title").html(json_data.product.title);
         $(thisitem).find(".wishlist-product-image a").attr("href",final_url);
    },
  });
 }else{
       jQuery.ajax({
    type: 'GET',
    url: data_url,
    dataType: 'json',
    success: function(json_data){  
   $(thisitem).find(".wishlist-product-title").html(json_data.product.title);
         $(thisitem).find(".wishlist-product-image a").attr("href",data_url);
    },
  });
 }
    }
    });
    document.addEventListener("click", function(event) {
        if (event.target.closest(".wishlist_cross_btn svg")) {
            var parentElement = event.target.closest(".main_wishlistinner-rpeater");
            if (parentElement) {
                var get_var_id = parentElement.getAttribute("variantid");
                var get_hash_value = window.WishListHero_SDK.GetWishListHash();
                var productInfo = {
                    ProductVariantId: get_var_id,
                    WishlistHash: get_hash_value
                };
                window.WishListHero_SDK.DeleteWishListItem(productInfo)
                    .then(function() {
                        var window_url = window.location.href;
                        fetch(window_url)
                            .then(function(response) {
                                return response.text();
                            })
                            .then(function(html_data) {
                                var parser = new DOMParser();
                                var doc = parser.parseFromString(html_data, "text/html");
                                var wishlistProductHere = doc.querySelector('.wishlist_product_here');
                                if (wishlistProductHere) {
                                    var wishlistItems = window.WishListHero_SDK.GetWishListItems();
                                    var wishlisthtml = '';
                                    wishlisthtml += '<div class="main_wishlist_page-wrapper">';
                                    for (let i = 0; i < wishlistItems.length; i++) {
  var getcurrency = wishlistItems[i].DisplayCurrency;
  var rounded_value = Math.round(wishlistItems[i].Price);
   var currency_price = (rounded_value).toLocaleString('en-US', {style: 'currency',currency: getcurrency,}); 
  var removed_zerrs = currency_price.replace(".00","");
                                        wishlisthtml += '<div class="main_wishlistinner-rpeater size_popup-parent" variantid="' + wishlistItems[i].ProductVariantId + '"><div class="wishlist-product-image"><a href="' + wishlistItems[i].ProductLink + '"><img src="' + wishlistItems[i].ProductImage + '"></a><div class="product_varinats_wrapp"></div><div class="wishlist_cross_btn"><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 1.32031L1.00006 17.8203" stroke="black" stroke-linecap="round"/><path d="M17.5 17.8203L1.00006 1.32037" stroke="black" stroke-linecap="round"/></svg></div></div><div class="wishlist-product-info"><a href="' + wishlistItems[i].ProductLink + '"><div class="wishlist-product-title">' + wishlistItems[i].ProductName + '</div><div class="wshlist-product-description"></div><div class="wishlist-pro-price">' + removed_zerrs + '</div></a></div></div>';
                                    }
                                    wishlisthtml += '</div>';
                                    document.querySelector(".wishlist_product_here").innerHTML = wishlisthtml;
                                    var wishlist_item_count2 = window.WishListHero_SDK.GetWishListItemsCount();
                                    document.querySelector(".wishlist_count").innerHTML = "(" + wishlist_item_count2 + ")";
                                    document.querySelector(".wishlist-hero-items-count").innerHTML = wishlist_item_count2;
                                    if (wishlist_item_count2 == 0) {
                                        document.querySelector('.wishlist_no_item').style.display = 'block';
                                    } else {
                                        document.querySelector('.wishlist_no_item').style.display = 'none';
                                    }
                                    document.querySelectorAll('.main_wishlistinner-rpeater').forEach(function(element) {
                                        var get_wishlist_url = element.querySelector('.wishlist-product-image a').getAttribute('href');
                                        var thisitem = element;
                                        var xhr = new XMLHttpRequest();
                                        xhr.open('GET', get_wishlist_url, true);
                                        xhr.onreadystatechange = function() {
                                            if (xhr.readyState === 4 && xhr.status === 200) {
                                                var response = xhr.responseText;
                                                var parser = new DOMParser();
                                                var htmlDoc = parser.parseFromString(response, 'text/html');
                                                thisitem.querySelector('.wshlist-product-description').innerHTML = htmlDoc.querySelector('.WishtListDesc').innerHTML;
                                                thisitem.querySelector('.product_varinats_wrapp').innerHTML = htmlDoc.querySelector('.wishlist_pro-data-pick').innerHTML;

                                            }
                                        };
                                        xhr.send();
                                    });
$(".main_wishlistinner-rpeater").each(function() {
  var data_url = $(this).find(".wishlist-product-image a").attr("href");
    var thisitem = $(this);
    if (window.location.href.indexOf("/fr/") > -1) {
 if (data_url.indexOf("/fr/") > -1) {
  jQuery.ajax({
    type: 'GET',
    url: data_url,
    dataType: 'json',
    success: function(json_data){  
    $(thisitem).find(".wishlist-product-title").html(json_data.product.title);
    $(thisitem).find(".wishlist-product-image a").attr("href",data_url);
    },
  });
 }else{
     var final_url="/fr"+data_url;
       jQuery.ajax({
    type: 'GET',
    url: final_url,
    dataType: 'json',
    success: function(json_data){  
   $(thisitem).find(".wishlist-product-title").html(json_data.product.title);
         $(thisitem).find(".wishlist-product-image a").attr("href",final_url);
    },
  });
 }
    }else{
         if (data_url.indexOf("/fr/") > -1) {
              var final_url= data_url.split("/fr")[1];
  jQuery.ajax({
    type: 'GET',
    url: final_url,
    dataType: 'json',
    success: function(json_data){  
        $(thisitem).find(".wishlist-product-title").html(json_data.product.title);
         $(thisitem).find(".wishlist-product-image a").attr("href",final_url);
    },
  });
 }else{
       jQuery.ajax({
    type: 'GET',
    url: data_url,
    dataType: 'json',
    success: function(json_data){  
   $(thisitem).find(".wishlist-product-title").html(json_data.product.title);
         $(thisitem).find(".wishlist-product-image a").attr("href",data_url);
    },
  });
 }
    }
    });
                                  
                                }
                            })
                            .catch(function(error) {
                                console.error('Error fetching data:', error);
                            });
                    })
                    .catch(function(error) {
                        console.error('Error deleting wishlist item:', error);
                    });
            }
        }
    });
});